import SelfToken from '../../views/Self/SelfToken'
import CreateToken from "../../views/CreateToken";

const SelfTokenPage = () => {
  return <SelfToken />
}

export default SelfTokenPage
